const STORAGE_KEY = 'sidebarCollapsed';
const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');
const LARGE_MQ = window.matchMedia('(min-width: 992px)');
const TABLET_MQ = window.matchMedia('(min-width: 768px) and (max-width: 991.98px)');

function applyState(sidebar, collapsed) {
  const mainContent = document.querySelector('.main-content');
  const alerts = document.querySelector('.dashboard-alerts');
  const header = document.querySelector('[data-app-header]');

  sidebar.classList.toggle('collapsed', collapsed);
  if (mainContent) {
    mainContent.classList.toggle('expanded', collapsed);
  }
  alerts?.classList.toggle('sidebar-collapsed', collapsed);
  header?.classList.toggle('sidebar-collapsed', collapsed);
}

function setDrawerOpen(sidebar, open, rootEl = document) {
  const backdrop = rootEl.querySelector('[data-sidebar-backdrop]');
  const trigger = rootEl.querySelector('[data-sidebar-open]');

  sidebar.classList.toggle('open', open);
  backdrop?.classList.toggle('show', open);
  trigger?.setAttribute('aria-expanded', String(open));

  // `inert` removes a closed drawer from the tab order on phones only; on
  // desktop the sidebar is always interactive.
  if (DESKTOP_MQ.matches) {
    sidebar.removeAttribute('inert');
  } else {
    sidebar.toggleAttribute('inert', !open);
  }
}

export function toggle(sidebarEl) {
  const collapsed = !sidebarEl.classList.contains('collapsed');

  applyState(sidebarEl, collapsed);
  sessionStorage.setItem(STORAGE_KEY, String(collapsed));
}

export function init(rootEl = document) {
  const sidebar = rootEl.querySelector('[data-sidebar]');

  if (!sidebar) {
    return;
  }

  const isMobile = () => !DESKTOP_MQ.matches;

  const applyMode = () => {
    if (isMobile()) {
      // Drawer mode: never inherit the desktop collapsed rail.
      applyState(sidebar, false);
      setDrawerOpen(sidebar, false, rootEl);
      return;
    }
    const saved = sessionStorage.getItem(STORAGE_KEY);
    // Tablet defaults to the icon rail (auto-collapse) but honors an explicit
    // expand; desktop defaults to expanded and remembers the user's choice.
    const collapsed = TABLET_MQ.matches ? saved !== 'false' : saved === 'true';
    applyState(sidebar, collapsed);
  };

  rootEl.querySelector('[data-sidebar-toggle]')?.addEventListener('click', () => {
    toggle(sidebar);
  });

  rootEl.querySelector('[data-sidebar-open]')?.addEventListener('click', () => {
    if (isMobile()) {
      setDrawerOpen(sidebar, !sidebar.classList.contains('open'), rootEl);
    } else {
      toggle(sidebar);
    }
  });

  const backdrop = rootEl.querySelector('[data-sidebar-backdrop]');
  backdrop?.addEventListener('click', () => {
    if (isMobile()) {
      setDrawerOpen(sidebar, false, rootEl);
    }
  });

  // Navigating closes the drawer on phones.
  sidebar.addEventListener('click', (event) => {
    if (isMobile() && event.target.closest('.sidebar-link, .nav-link')) {
      setDrawerOpen(sidebar, false, rootEl);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && sidebar.classList.contains('open')) {
      setDrawerOpen(sidebar, false, rootEl);
    }
  });

  DESKTOP_MQ.addEventListener('change', applyMode);
  LARGE_MQ.addEventListener('change', applyMode);
  applyMode();
}
